import { render, staticRenderFns } from "./CRStatus.vue?vue&type=template&id=2a89127e"
import script from "./CRStatus.vue?vue&type=script&lang=js"
export * from "./CRStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports